Picture = {
    pictures: {},

    init:function(collection){

        if(typeof Editor != "undefined") return;

        collection = collection ? collection : $('body');

        this.pictures = collection.find('[data-type="image"]');

        this.pictures.each(function(index, el) {

            var ratio = $(this).attr('data-height') /  $(this).attr('data-width');
            if(!ratio) {
                return;
            }
            $(this).css({position: 'relative'});

            var img = $(this).find('img');
            var url = img.attr('src');

            img.height($(this).width() * ratio);
            img.css({opacity: '0'});

            Picture.Loader.create($(this))
            
            img.load(function(event) {
                Picture.Loader.remove($(this).closest('[data-type="image"]'))
                $(this).animate({opacity:1}, 300, function(){
                     $(this).removeAttr('style');
                     $(this).closest('.image').removeAttr('style');
                });
            });
            
            img.attr('src', url);
        });
    },

    Loader : {
        create: function(obj){
            $('<div>', {'class': 'image-loading'})
                .appendTo(obj)
        },

        remove: function(obj){
            obj.find('.image-loading').remove();
        }
    }
}